var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40627 1.56865C5.72637 0.69318 6.96454 0.693182 7.28464 1.56865L7.97922 3.4683C8.1234 3.86262 8.49853 4.12489 8.91838 4.1249L10.8908 4.12497C11.8877 4.125 12.2707 5.42419 11.4332 5.96503L10.0483 6.85937C9.65592 7.11276 9.49122 7.60404 9.65159 8.04275L10.2268 9.61642C10.5562 10.5173 9.55103 11.3202 8.74518 10.7998L6.88788 9.60064C6.55769 9.38744 6.13322 9.38744 5.80303 9.60064L3.94573 10.7998C3.13987 11.3202 2.13475 10.5173 2.46408 9.61642L3.03932 8.04275C3.19969 7.60405 3.03498 7.11276 2.64259 6.85937L1.25768 5.96503C0.42017 5.42419 0.803174 4.125 1.80013 4.12497L3.77253 4.1249C4.19238 4.12489 4.56751 3.86262 4.71168 3.4683L5.40627 1.56865Z",
    fill: "#81418D",
    fillOpacity: 0.58,
    stroke: "#81418D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon (5).b8d376f58a784f6b9241f90bfc37a600.svg";
export { ForwardRef as ReactComponent };